export const homeRoute = "/";
export const aboutMeRoute = "/about-me";
export const mobileRoute = "/mobile";
export const webRoute = "/web";
export const productDesignsRoute = "/product-mechanical-designs";
export const otherProjectsRoute = "/other-projects";
export const contactRoute = "/contact";
export const adminRoute = "/admin";
export const macrosRoute = "/macros"